import { useState } from "react";
import PageLayout from "../../components/PageLayout";
import { Button, Card, Grid, TextField, Typography } from "@mui/material";
import { FaPaperPlane } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import globalToast from "../../components/common/globalToast";
import { sendResetPasswordToken, updatePassword, validateResetPasswordToken } from "../../helpers/http_password_requests";
import { useAuth } from "../../providers/AuthProvider";

export default function ResetPassword() {

    const [step, setStep] = useState(0);
    const [token, setToken] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const navigate = useNavigate();

    const { signOut } = useAuth();

    const handleProgressStep = () => setStep((prev) => prev + 1);

    const validatePassword = (senha) => {
        const minLength = senha.length >= 8;
        const hasUpper = /[A-Z]/.test(senha);
        const hasLower = /[a-z]/.test(senha);
        const hasNumber = /[0-9]/.test(senha);
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(senha);
        return minLength && hasUpper && hasLower && hasNumber && hasSpecial;
    };

    const handleValidateToken = async () => {
        const response = await validateResetPasswordToken(token);

        if (response.success) {
            handleProgressStep();
        } else {
            globalToast.error("Ocorreu um erro ao validar o token. Verifique o código e tente novamente.");
        };
    };

    const handleSendToken = async () => {
        const response = await sendResetPasswordToken();

        if (response.success) {
            handleProgressStep();
        } else {
            globalToast.error("Ocorreu um erro ao enviar o token. Tente novamente.");
        };
    };

    const handleUpdatePassword = async () => {
        if (!password || !confirmPassword) {
            globalToast.error("Preencha todos os campos.");
            return;
        }

        if (password !== confirmPassword) {
            globalToast.error("As senhas não coincidem.");
            return;
        }

        if (!validatePassword(password)) {
            globalToast.error("A senha não atende aos critérios de segurança.");
            return;
        }

        const response = await updatePassword(password);

        if (response.success) {
            globalToast.success("Senha redefinida com sucesso!");
            signOut();
            navigate("/");
        } else {
            globalToast.error("Ocorreu um erro ao enviar o token. Tente novamente.");
        }
    };

    // Conteúdo de cada etapa
    const renderStepContent = () => {
        switch (step) {
            case 0:
                return (
                    <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', padding: '1rem' }}>
                        <Typography textAlign={'left'} fontSize={20} mb={'1.5rem'}>
                            Para começar o processo de redefinição de senha, enviaremos um token para seu e-mail.
                        </Typography>
                        <Button onClick={handleSendToken} startIcon={<FaPaperPlane />} variant="contained" color="secondary">
                            Enviar token e iniciar
                        </Button>
                    </Card>
                );
            case 1:
                return (
                    <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', padding: '1rem' }}>
                        <Typography textAlign={'left'} fontSize={20} mb={'1.5rem'}>
                            Insira o token enviado para o e-mail de cadastro desta conta
                        </Typography>
                        <TextField
                            sx={{ mb: '1rem' }}
                            placeholder="999888ABC"
                            value={token}
                            onChange={(e) => setToken(e.target.value)}
                        />
                        <Button onClick={handleValidateToken} variant="contained" color="secondary">
                            Validar token
                        </Button>
                    </Card>
                );
            case 2:
                return (
                    <Card component={Grid} container spacing={2} sx={{ padding: '1rem' }}>
                        <Grid item size={12}>
                            <Typography textAlign={'left'} fontSize={20} >
                                Insira uma senha nova
                            </Typography>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <TextField
                                type="password"
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                helperText="Mín. 8 caracteres, incluindo maiúsculas, minúsculas, números e símbolos."
                                placeholder="SenhaForte12@"
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <TextField
                                type="password"
                                fullWidth
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                helperText="Repita sua senha."
                                placeholder="SenhaForte12@"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button onClick={handleUpdatePassword} variant="contained" color="secondary">
                                Alterar senha
                            </Button>
                        </Grid>
                    </Card>
                );
            default:
                return null;
        };
    };

    return (
        <PageLayout pageTitle={"Redefinição de Senha"}>
            {renderStepContent()}
        </PageLayout>
    );
}
